import { Directive, ElementRef, Injector, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudDataSource, CrudListComponent, FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { AssetsUser, REF_CODE_TYPE, RefCode, RefCodeKey } from 'assets-model';
import { RefCodeDataSource, RefCodeService } from 'assets-service';


@Directive()
export abstract class RefCodeSearchComponentBase extends CrudListComponent<RefCode, RefCodeKey> {
  protected systemConfig: any;

  displayedColumns: string[] = [ 'code', 'domain', 'meaning', 'val1', 'val2', 'actions'];

  public searchForm: FormGroup;

  codeFilter: string;
  @ViewChild('codeFilterInput') codeFilterInput: ElementRef;

  domainFilter: string;
  @ViewChild('domainFilterInput') domainFilterInput: ElementRef;

  meaningFilter: string;
  @ViewChild('meaningFilterInput') meaningFilterInput: ElementRef;

  val1Filter: string;
  @ViewChild('val1FilterInput') val1FilterInput: ElementRef;

  val2Filter: string;
  @ViewChild('val2FilterInput') val2FilterInput: ElementRef;


  get eAssetsUser(): AssetsUser {
    return AssetsUser.assignAs(this.userDetails);
  }

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected refCodeService: RefCodeService,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(REF_CODE_TYPE, route, router, userStorage, dialog, refCodeService, injector);

    this.searchForm = this.fb.group({
      code: [null],
      domain: [null],
      meaning: [null],
      val1: [null],
      val2: [null]
    });
  }

  createDataSource(): CrudDataSource<RefCode> {
    return new RefCodeDataSource(this.refCodeService);
  }

  createServiceArguments(): any {
    return {
      code: this.codeFilter,
      domain: this.domainFilter,
      meaning: this.meaningFilter,
      val1: this.val1Filter,
      val2: this.val2Filter
    };
  }
  
  clearFiltersBeforeLoadPage() {
    this.restoreFormFromParams(this.searchForm);
  }
  
  clearFilterVariables() {
    this.codeFilter = null;
    this.domainFilter = null;
    this.meaningFilter = null;
    this.val1Filter = null;
    this.val2Filter = null;
  }
  
  clearFilters() {
    this.clearFilterVariables();
    this.clearFiltersBeforeLoadPage();
    this.loadPage();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.addSearchOnChangedInputEventListener(this.codeFilterInput);
    this.addSearchOnChangedInputEventListener(this.domainFilterInput);
    this.addSearchOnChangedInputEventListener(this.meaningFilterInput);
    this.addSearchOnChangedInputEventListener(this.val1FilterInput);
    this.addSearchOnChangedInputEventListener(this.val2FilterInput);
    this.formStorage.rememberFormChanges(this.searchForm);
  }

  ngOnInit() {
    super.ngOnInit();
  }
  
  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
  }

  protected initExportOptions(config: any): any {
    config = config || {};
    return config;
  }

  protected initConfig(config: any) {
    super.initConfig(config);
    this.systemConfig = this.initExportOptions(config);
  }
  
  protected transformAllPropertiesToModelSetters(): {
    [key: string]: (value: any, formControl: FormControl, formControlName: string) => void
  } {
    const self = this;
    return {
      code: (value: string) => self.codeFilter = value,
      domain: (value: string) => self.domainFilter = value,
      meaning: (value: string) => self.meaningFilter = value,
      val1: (value: string) => self.val1Filter = value,
      val2: (value: string) => self.val2Filter = value
    }
  }
  
  restoreFormChanges() {
    const self = this;

    // IMPORTANT that the restoreFormChanges call occurs before the initial search - typically best done in onInitAsyncComplete
    // Whereever a form control binds with [ngModel] to a reactive form, ngModel takes precedence,
    // and needs it's own setter function to set the scope attribute bound
    this.formStorage.restoreFormChanges(this.searchForm, this.transformAllPropertiesToModelSetters());
  }

  codeChanging(value: string, unsetDependents: boolean = true) {}
  
  codeChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  domainChanging(value: string, unsetDependents: boolean = true) {}
  
  domainChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  meaningChanging(value: string, unsetDependents: boolean = true) {}
  
  meaningChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  val1Changing(value: string, unsetDependents: boolean = true) {}
  
  val1Changed(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  val2Changing(value: string, unsetDependents: boolean = true) {}
  
  val2Changed(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  disabledTooltip(element) {
    if (!element) {
      return true;
    }
    return element.valid || !element.touched;
  }

  get code() {
    return this.searchForm && this.searchForm.get('code');
  }

  get domain() {
    return this.searchForm && this.searchForm.get('domain');
  }

  get meaning() {
    return this.searchForm && this.searchForm.get('meaning');
  }

  get val1() {
    return this.searchForm && this.searchForm.get('val1');
  }

  get val2() {
    return this.searchForm && this.searchForm.get('val2');
  }


}



